<template>
  <div
    style="
      width: 297mm;
      height: 840mm;
      border: 1px solid black;
      margin: 5mm;
      visibility: hidden;
    "
  >
    <div id="pdf-resort-view-client">
      <div class="columns is-multiline">
        <section class="hero">
          <div class="hero-body">
            <p class="title">
              <b>{{ ResortName }}</b>
            </p>
            <p class="subtitle">{{ FullAddress }}.</p>
          </div>
        </section>
      </div>

      <div class="columns is-multiline">
        <div class="card" style="margin: 0 20mm 20mm 20mm">
          <div class="card-image">
            <img
              :src="`data: image/png;base64, ${img1}`"
              alt="img"
              style="width: 300mm; height: 150mm"
            />
          </div>
        </div>
      </div>

      <div class="columns is-multiline" style="margin: -20mm 5mm 0 5mm">
        <div class="column is-6">
          <section class="hero">
            <div class="hero-body content has-text-centered">
              <p class="title">
                <small>{{ i18n.date[iso] }}</small>
              </p>
              <p class="subtitle">
                <small> <b>Check In:</b> {{ CheckIn }} </small> <br />
                <small> <b>Check Out:</b> {{ CheckOut }}</small>
              </p>
            </div>
          </section>
        </div>
        <div class="column is-6">
          <section class="hero">
            <div class="hero-body content has-text-centered">
              <p class="title">
                <small>{{ i18n.priceTotal[iso] }}</small>
              </p>
              <p class="subtitle">
                US$ <b>{{ Cost }}</b>
              </p>
            </div>
          </section>
        </div>
        <div class="column is-12">
          <section class="hero">
            <div class="hero-body content has-text-centered">
              <p class="title">
                <small>{{ i18n.contact[iso] }}</small>
              </p>
              <p class="subtitle">
                <small>{{ ContactEmail }}</small> <br />
                <small>{{ ContactPhone }}</small>
              </p>
            </div>
          </section>
        </div>
      </div>

      <div class="columns is-multiline" style="margin: 5mm">
        <div class="column is-4">
          <div class="card">
            <div class="card-image">
              <img
                :src="`data: image/png;base64, ${img2}`"
                alt="img"
                style="width: 100mm; height: 60mm"
              />
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="card">
            <div class="card-image">
              <img
                :src="`data: image/png;base64, ${img3}`"
                alt="img"
                style="width: 100mm; height: 60mm"
              />
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="card">
            <div class="card-image">
              <img
                :src="`data: image/png;base64, ${img4}`"
                alt="img"
                style="width: 100mm; height: 60mm"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="columns is-multiline" style="margin: 5mm">
        <!-- <div class="column is-3">
          <b-message
            :title="i18n.reputation[iso]"
            size="is-small"
            :closable="false"
            style="height: 25mm"
            type="is-info"
          >
            <b-rate
              class="center_"
              v-model="Rating"
              icon-pack="fas"
              icon="star"
              :show-score="true"
              :spaced="true"
              size="is-medium"
              :disabled="true"
            ></b-rate>
          </b-message>
        </div> -->
        <div class="column is-3">
          <b-message
            :title="i18n.nights[iso]"
            size="is-small"
            :closable="false"
            style="height: 25mm"
            type="is-info"
          >
            <p class="center_" style="font-size: 4mm; font-weight: 600">
              <b-icon
                pack="fas"
                icon="moon"
                size="is-small"
                style="margin-right: 1mm"
              >
              </b-icon>
              {{ Nights }} {{ i18n.nights[iso] }}
            </p>
          </b-message>
        </div>
        <div class="column is-3">
          <b-message
            :title="i18n.kitchen[iso]"
            size="is-small"
            :closable="false"
            style="height: 25mm"
            type="is-info"
            ><p class="center_" style="font-size: 4mm; font-weight: 600">
              <b-icon
                pack="fas"
                icon="utensils"
                size="is-small"
                style="margin-right: 1mm"
              >
              </b-icon>
              {{ Kitchen }}
            </p>
          </b-message>
        </div>
        <div class="column is-3">
          <b-message
            :title="i18n.type[iso]"
            size="is-small"
            :closable="false"
            style="height: 25mm"
            type="is-info"
          >
            <p class="center_" style="font-size: 4mm; font-weight: 600">
              <b-icon
                pack="fas"
                icon="hotel"
                size="is-small"
                style="margin-right: 1mm"
              >
              </b-icon>
              {{ Type }}
            </p>
          </b-message>
        </div>
        <div class="column is-3">
          <b-message
            :title="i18n.occupancyMax[iso]"
            size="is-small"
            :closable="false"
            style="height: 25mm"
            type="is-info"
          >
            <p class="center_" style="font-size: 4mm; font-weight: 600">
              <b-icon
                pack="fas"
                icon="users"
                size="is-small"
                style="margin-right: 1mm"
              >
              </b-icon>
              {{ Ocuppancy }} {{ i18n.people[iso] }}
            </p>
          </b-message>
        </div>
      </div>

      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="content" style="margin: 10mm; text-align: justify">
            <h2>{{ i18n.description[iso] }}:</h2>
            <p v-html="Description"></p>
          </div>
        </div>

        <div class="column is-12">
          <div class="content" style="margin: 10mm; text-align: justify">
            <h2>{{ i18n.notesImportant[iso] }}:</h2>
            <p v-html="ImportantNotes"></p>
          </div>
        </div>
      </div>

      <div class="columns is-multiline" style="margin: 10mm">
        <div class="column is-12">
          <div class="content" style="text-align: justify">
            <h2>Amenities</h2>
          </div>
        </div>
        <div
          v-if="Amenities.split(',').length > 0"
          class="column is-3"
          v-for="(amenity, i) in Amenities.split(',')"
          :key="i"
        >
          <div class="">
            <b-icon
              pack="fas"
              icon="check-circle"
              size="is-small"
              type="is-success"
              style="margin-right: 1mm"
            >
            </b-icon>
            {{ amenity }}
          </div>
        </div>
      </div>

      <div class="columns is-multiline" style="margin: 20mm">
        <div class="column is-12">
          <div class="center_">
            <img
              :src="LogoClub"
              alt="img"
              style="width: 60mm"
              class="center_"
            />
            <br />
            <p>{{ FullAddressClub }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
const API_URL = process.env.VUE_APP_API_URL;
import i18n from "../../utils/i18n";

export default {
  name: "VacancyBackofficeResortViewClient",

  data() {
    return {
      i18n,
      iso: null,

      img1: null,
      img2: null,
      img3: null,
      img4: null,

      ResortName: null,
      FullAddress: null,
      Cost: null,
      Amenities: null,
      Description: null,
      CheckIn: null,
      CheckOut: null,
      ImportantNotes: null,
      ContactEmail: null,
      ContactPhone: null,
      Rating: null,
      Nights: null,
      Kitchen: null,
      Type: null,
      Ocuppancy: null,
      LogoClub: null,
      FullAddressClub: null,
    };
  },

  async created() {
    this.iso = localStorage.getItem("iso");
    this.$bus.on("change-iso", () => {
      this.iso = localStorage.getItem("iso");
    });

    const pdfResort__ = localStorage.getItem("payloadPdfResort");

    if (!pdfResort__) {
      window.close();
    } else {
      const pdfResort = JSON.parse(pdfResort__);
      this.ResortName = pdfResort?.ResortName;
      this.FullAddress = pdfResort?.FullAddress;
      this.Cost = pdfResort?.Cost;
      this.Amenities = pdfResort?.Amenities;
      this.Description = pdfResort?.Description;
      this.CheckIn = pdfResort?.CheckIn;
      this.CheckOut = pdfResort?.CheckOut;
      this.ImportantNotes = pdfResort?.ImportantNotes;
      this.ContactEmail = pdfResort?.ContactEmail;
      this.ContactPhone = pdfResort?.ContactPhone;
      this.Rating = parseFloat(pdfResort?.Rating).toFixed(1);
      this.Nights = pdfResort?.Nights;
      this.Kitchen = pdfResort?.Kitchen;
      this.Type = pdfResort?.Type;
      this.Ocuppancy = pdfResort?.Ocuppancy;
      this.LogoClub = pdfResort?.LogoClub;
      this.FullAddressClub = pdfResort?.FullAddressClub;

      this.img1 = await this.imgToBase64(pdfResort?.img1);
      this.img2 = await this.imgToBase64(pdfResort?.img2);
      this.img3 = await this.imgToBase64(pdfResort?.img3);
      this.img4 = await this.imgToBase64(pdfResort?.img4);

      const element = document.getElementById("pdf-resort-view-client");
      const opt = {
        margin: 1,
        filename: `${this.ResortName}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2.5, useCORS: true },
        jsPDF: { unit: "mm", format: [297, 840], orientation: "portrait" },
      };

      await html2pdf().from(element).set(opt).save();
      // await window.close();
    }
  },

  async mounted() {},

  methods: {
    async imgToBase64(url) {
      try {
        const { data } = await axios.get(
          `${API_URL}/utils/img-to-base64?url=${url}`
        );
        return data.base64;
      } catch (error) {
        return `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`;
      }
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");

#pdf-resort-view-client {
  font-family: Poppins;
  color: #222831;
}

.center_ {
  max-width: fit-content;
  margin-left: auto;
  margin-right: auto;
}
/* .flex {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
footer {
  margin-top: auto;
} */
</style>
